'use strict';

var multiSelectCtrl = ['$timeout', function ($timeout) {
    var _this = this;

    _this.allOptions = JSON.parse(JSON.stringify(_this.options?.sort())) || [];
    _this.availableOptions = JSON.parse(JSON.stringify(_this.allOptions));
    _this.selectedOptions = [];
    _this.selectedOption = null;

    _this.addOption = function () {
        if (!_this.selectedOption || _this.selectedOptions.includes(_this.selectedOption)) {
            return;
        }
        _this.selectedOptions.push(_this.selectedOption);
        const index = _this.availableOptions.indexOf(_this.selectedOption);
        if (index > -1) {
            _this.availableOptions.splice(index, 1);
        }
        _this.selectedOption = null;
    };

    _this.removeOption = function (index) {
        const removedOption = _this.selectedOptions.splice(index, 1)[0];
        if (removedOption) {
            _this.availableOptions.push(removedOption);
        }
    };
    _this.removeAll = function () {
        _this.availableOptions = JSON.parse(JSON.stringify(_this.allOptions));
        _this.selectedOptions = [];
    }
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            options: '=',
            selectedOptions: '=',
            legend: '@'
        },
        replace: true,
        controller: multiSelectCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/multiSelectDirective.html'
    };
};
